

import Vue from 'vue'

const transformer = function({ widget, user }) {
  return {
    user,
    widget: {
      color: widget.wid_color,
      imagePath: widget.wid_image_path,
      message: widget.wid_message,
      name: widget.wid_name
    }
  }
}

export default message =>
  Vue.$http.post('avi_chat/login/')
    .then(response => transformer(response.data))




// WEBPACK FOOTER //
// ./src/services/chat/login.js